import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { parseQuery } from "lib/utils/socialtravel";
import CSSModules from "lib/utils/css-modules";
import {
  Modal,
  MainView,
  Message,
  Link,
  OrdersList,
  Form,
  FormControl,
  Button,
  StockAvailability,
  OrderFullDecorator,
  st,
} from "lib/index";
import { saleWindowStatus } from "lib/utils/saleWindow";
import { open as openNewOrderModal } from "modules/orders/NewOrderModal";
import { stateSelector, close, fetchSlot, updateSlot, submit, openManifest } from "./index";
import styles from "./ShowSlotModal.less";

@connect(
  (state) => ({
    currentCompanyId: state.auth.company.model.id,
    company: state.auth.company.model,
    enable_saas: state.auth.company.model.enable_saas,
    opened: stateSelector(state).opened,
    initialSlot: stateSelector(state).slot.model,
    slot: stateSelector(state).editedSlot.model,
    fetchDone: stateSelector(state).slot.fetchDone,
    fetchLoading: stateSelector(state).slot.fetchLoading,
    fetchFailed: stateSelector(state).slot.fetchFailed,
    dirty: stateSelector(state).editedSlot.dirty,
    submitLoading: stateSelector(state).editedSlot.submitLoading,
    submitFailed: stateSelector(state).editedSlot.submitFailed,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        openNewOrderModal,
        close,
        fetchSlot,
        updateSlot,
        submit,
        openManifest,
      },
      dispatch
    )
)
@CSSModules(styles)
export default class ShowSlotModal extends React.PureComponent {
  componentDidUpdate(prevProps) {
    this.handleActionParam();
  }
  componentDidMount() {
    this.handleActionParam();
  }

  handleActionParam() {
    const query = parseQuery(window.location.search);
    if (query && query.showSlot && query.action === "book") {
      if (!this.props.slot) {
        this.props.fetchSlot();
      }
      this.handleNewOrderClick();
    }
  }

  handleFormSubmit(event) {
    event.preventDefault();
    this.props.submit();
  }

  handleSlotPropChange(prop, value) {
    const { slot, updateSlot } = this.props;
    updateSlot({
      ...slot,
      [prop]: value,
    });
  }

  handleNewOrderClick() {
    const { slot, openNewOrderModal } = this.props;
    openNewOrderModal(this._createOrderForSlot());
  }

  handleManifestClick() {
    this.props.openManifest();
  }

  _createOrderForSlot() {
    let { slot } = this.props;

    slot = slot || this.props.initialSlot;
    if (!slot) return;

    const company = slot.company ? slot.product.company : slot.company_id;

    return new OrderFullDecorator.build({
      company: slot.product.company,
      agent: slot.product.company.id !== st.authorize.company.id ? st.authorize.company : null,
      product: slot.product,
      product_variant: slot.product_variant,
      product_schedule_slot: slot,
    });
  }

  canEdit() {
    return this.props.slot.company_id === st.authorize.company.id;
  }

  renderContent() {
    const { currentCompanyId, slot, dirty, submitLoading, submit, enable_saas, company } = this.props;
    const saleWindowBadge = slot && saleWindowStatus(slot);
    return (
      slot && (
        <div styleName="container">
          <div styleName="product-title">
            <div styleName="product-name">
              {slot.product && !this.canEdit() && <span>{slot.product.name} </span>}
              {slot.product && this.canEdit() && (
                <Link to={`/c/${currentCompanyId}/products/${slot.product.id}/edit`}>{slot.product.name}</Link>
              )}
              {!slot.product && slot.product_name}
            </div>
            {!!slot.product_variant_name && <div styleName="product-variant-name">{slot.product_variant_name}</div>}
          </div>

          <div styleName="slot-section">
            <div styleName="slot-options">
              <div styleName="slot-options-left">
                <div styleName="slot-date">
                  {st.formatTimeRange(slot.starts_at, slot.ends_at, {
                    includeTime: slot.includes_time,
                  })}
                </div>
                <div styleName="slot-availability">
                  <StockAvailability slot={slot} />
                </div>
              </div>

              <div styleName="slot-options-right">
                {slot.active &&
                  slot.product &&
                  slot.product.active &&
                  (st.authorize("create", this._createOrderForSlot()) || st.authorize.company.reseller) && (
                    <Button
                      as="a"
                      primary
                      floated="right"
                      onClick={this.handleNewOrderClick.bind(this)}
                      content={I18n.t("papp.calendar.ShowSlotModal.build_order")}
                    />
                  )}

                {st.authorize.company.reseller && (
                  <Button
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      window.open(
                        "http://" + company.saas_host.split("old.", "").join("") + "/p/" + slot.product.id,
                        "_blank"
                      );
                    }}
                    content={I18n.t("papp.components.ProductsListItem.preview_marketplace")}
                  />
                )}
                {st.authorize("read_manifest", slot) && this.canEdit() && (
                  <Button
                    as="a"
                    color="grey"
                    floated="right"
                    onClick={this.handleManifestClick.bind(this)}
                    content={I18n.t("papp.calendar.ShowSlotModal.open_manifest")}
                  />
                )}
              </div>
            </div>

            <Form loading={submitLoading} onSubmit={this.handleFormSubmit.bind(this)}>
              <div className="fields inline">
                <FormControl.CheckboxFormGroup
                  value={slot.active}
                  disabled={!this.canEdit()}
                  onChange={this.handleSlotPropChange.bind(this, "active")}
                  label={I18n.humanAttributeName("product_schedule_slot", "active")}
                  toggle
                />

                {enable_saas && (
                  <FormControl.CheckboxFormGroup
                    value={slot.confirmed}
                    disabled={!this.canEdit()}
                    onChange={this.handleSlotPropChange.bind(this, "confirmed")}
                    label={I18n.humanAttributeName("product_schedule_slot", "confirmed")}
                    toggle
                  />
                )}

                <FormControl.NumberLimitFormGroup
                  value={slot.total_stock_limit}
                  disabled={!this.canEdit()}
                  onChange={this.handleSlotPropChange.bind(this, "total_stock_limit")}
                  label={I18n.humanAttributeName("product_schedule_slot", "total_stock_limit")}
                  inlineLabel
                  min={1}
                />

                {dirty && (
                  <Button type="submit" primary onClick={submit} content={I18n.t("papp.common.save_changes")} />
                )}
              </div>

              {/* Sale window editor + Biledo metadata. Operator can
                  override sale_starts_at / sale_ends_at only for native
                  slots; slots linked to Biledo (connectly_slot present)
                  have these fields disabled because the next sync will
                  overwrite anything we save here — Biledo owns the
                  window then. Lossy edit suppressed at the source. */}
              <div styleName="sale-window-section">
                <h4>{I18n.t("papp.calendar.ShowSlotModal.sale_window_title")}</h4>
                <div className="fields inline">
                  <FormControl.DateTimeFormGroup
                    value={slot.sale_starts_at}
                    disabled={!this.canEdit() || !!slot.connectly_slot}
                    timeZoneName={slot.time_zone_name}
                    onChange={this.handleSlotPropChange.bind(this, "sale_starts_at")}
                    label={I18n.t("papp.calendar.ShowSlotModal.sale_starts_at_label")}
                  />
                  <FormControl.DateTimeFormGroup
                    value={slot.sale_ends_at}
                    disabled={!this.canEdit() || !!slot.connectly_slot}
                    timeZoneName={slot.time_zone_name}
                    onChange={this.handleSlotPropChange.bind(this, "sale_ends_at")}
                    label={I18n.t("papp.calendar.ShowSlotModal.sale_ends_at_label")}
                  />
                </div>
                {saleWindowBadge && (
                  <div styleName={saleWindowBadge.styleName}>
                    {I18n.t(`papp.calendar.ShowSlotModal.${saleWindowBadge.labelKey}`)}
                  </div>
                )}
              </div>

              {slot.connectly_slot && (
                <div styleName="biledo-section">
                  <h4>{I18n.t("papp.calendar.ShowSlotModal.biledo_block_title")}</h4>
                  <div styleName="biledo-overwrite-warning">
                    {I18n.t("papp.calendar.ShowSlotModal.biledo_overwrite_warning")}
                  </div>
                  <dl styleName="biledo-meta">
                    <dt>{I18n.t("papp.calendar.ShowSlotModal.biledo_term_uuid")}</dt>
                    <dd><code>{slot.connectly_slot.term_uuid}</code></dd>
                    <dt>{I18n.t("papp.calendar.ShowSlotModal.biledo_pricelist_uuid")}</dt>
                    <dd><code>{slot.connectly_slot.pricelist_uuid}</code></dd>
                  </dl>
                </div>
              )}
            </Form>
          </div>

          <hr />

          {slot.orders.length === 0 && <Message>{I18n.t("papp.calendar.ShowSlotModal.no_orders_message")}</Message>}

          {!!slot.orders.find((o) => o.active) && (
            <div className="ui section">
              <h3>{I18n.t("papp.calendar.ShowSlotModal.active_orders_title")}</h3>
              {!!slot.orders.find((o) => o.active && o.allocates_stock) && (
                <div className="ui section">
                  <h4>{I18n.t("papp.calendar.ShowSlotModal.booked_orders_title")}</h4>
                  <OrdersList orders={slot.orders.filter((o) => o.active && o.allocates_stock)} />
                </div>
              )}
              {!!slot.orders.find((o) => o.active && !o.allocates_stock) && (
                <div className="ui section">
                  <h4>{I18n.t("papp.calendar.ShowSlotModal.awaiting_orders_title")}</h4>
                  <OrdersList orders={slot.orders.filter((o) => o.active && !o.allocates_stock)} />
                </div>
              )}
            </div>
          )}

          {!!slot.orders.find((o) => !o.active) && (
            <div className="ui section">
              <h3>{I18n.t("papp.calendar.ShowSlotModal.other_orders_title")}</h3>
              <OrdersList orders={slot.orders.filter((o) => !o.active)} />
            </div>
          )}
        </div>
      )
    );
  }

  render() {
    const { opened, fetchLoading, fetchFailed, fetchDone, fetchSlot, close } = this.props;
    return (
      opened && (
        <Modal closeIcon closeOnDimmerClick={false} open onClose={() => close()}>
          <Modal.Content style={{ minHeight: "500px" }}>
            <MainView.Dimmer loading={fetchLoading} failed={fetchFailed} retry={fetchSlot} />
            {this.renderContent()}
          </Modal.Content>
        </Modal>
      )
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/calendar/ShowSlotModal/ShowSlotModal.jsx